import Vue from 'vue'
import XLSX from 'xlsx'

export const EventBus = new Vue()
export function isValidJwt (jwt) {
  if (!jwt || jwt.split('.').length < 3) {
    return false
  }
  const data = JSON.parse(atob(jwt.split('.')[1]))
  const exp = new Date(data.exp * 1000)
  const now = new Date()
  return now < exp
}
export function exportXls (dataToExcel,json_fields, tableName) {
  dataToExcel.forEach(function f (elem) {
        Object.keys(elem).forEach(function (key) {
            if (typeof elem[key] === 'object') {
              if (Array.isArray(elem[key])) {
                elem[key] = elem[key].map(n => n.value)
                elem[key] = elem[key].join()
              }
              else {
                if ( elem[key] !== null && 'name' in elem[key])  elem[key] = elem[key].name
              // if ('value' in elem[key])  elem[key] = elem[key].value
              }
              }

      })
      })
      let tabdata = XLSX.utils.json_to_sheet(dataToExcel)

      var range = XLSX.utils.decode_range(tabdata['!ref'])
      // let vm = this
      for(var C = range.s.r; C <= range.e.r; ++C) {
        var address = XLSX.utils.encode_col(C) + "1" // <-- first row, column number C
        if(!tabdata[address]) continue
        tabdata[address].v = json_fields[tabdata[address].v]
      }
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      let wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, tabdata, tableName) // sheetAName is name of Worksheet

      // export Excel file
      XLSX.writeFile(wb, tableName+'.xlsx') //
}


// WEBPACK FOOTER //
// ./src/utils/index.js